import React from "react";
import { useNavigate } from "react-router";

import useAppInsightsHandler from "hooks/useAppInsightsHandler.js";

import { focusDefaultTabInInsights } from "utils/insightsAndAlarmsUtils";
import { getInsightsPagePath } from "utils/router.utils";

import AgTable from "components/AgTable";

import { getInsightListTableConfig } from "./Insightlist.table.config";

// eslint-disable-next-line react/display-name
const SmartInsightTable = React.memo(({ anomalyList, filterValue, showTableFilterIcon, setFilterAnomaly }) => {
  const navigate = useNavigate();
  const columdefs = getInsightListTableConfig(showTableFilterIcon);

  const objAppInsights = useAppInsightsHandler();

  const handleClickOnAlarmRow = event => {
    objAppInsights.trackEvent("smartInsightsRowClick");
    focusDefaultTabInInsights();
    const { SystemId } = event.data;
    const path = getInsightsPagePath(SystemId);
    navigate(path);
  };

  return (
    <AgTable
      rowData={anomalyList}
      columnDefs={columdefs}
      customHeight="300px"
      quickFilterText={filterValue}
      onRowClicked={handleClickOnAlarmRow}
      setBadgeCount={setFilterAnomaly}
      suppressScrollOnNewData
    />
  );
});

export default SmartInsightTable;
